import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { ABOUT } from '@/components/landing/about/data'
import { RESUME } from '@/components/landing/cabinet/data'

import {
    ARC,
    PixelPanel,
    PixelPortrait,
    SectionHead,
    StageTitle
} from '@/components/generals/arcade'

/* the character sheet: who on the left, the story on the right */
const Profile: FC = (): ReactNode => {
    return (
        <section id='profile' className={ARC.section} aria-labelledby='profile-title' tabIndex={-1}>
            <StageTitle stage="Stage 01" title="Player profile" id='profile-title' />

            <PixelPanel>
                <div className='grid md:grid-cols-[minmax(0,0.85fr)_6px_minmax(0,1.35fr)]'>
                    <div className='flex min-w-0 flex-col gap-6 p-6 md:p-10'>
                        <div className='flex flex-col gap-2'>
                            <p className={cn(ARC.outline, 'm-0 text-[26px] leading-none normal-case lg:text-[34px]')}>{RESUME.name}</p>
                            <p className={cn(ARC.pixel, 'm-0 text-xs tracking-[0.12em] text-(--cab-teal)')}>{RESUME.role}</p>
                        </div>

                        <PixelPortrait />

                        <div className='flex flex-col gap-4'>
                            <SectionHead icon='person' label="Stats" />
                            <dl className='m-0 flex flex-col gap-3'>
                                {ABOUT.stats.map((s) => (
                                    <div key={s.label} className='flex items-baseline gap-3'>
                                        <dt
                                            className={cn(
                                                ARC.label,
                                                'flex min-w-24 flex-1 items-baseline gap-2.5',
                                                'after:min-w-3.5 after:flex-1 after:-translate-y-[3px] after:border-b-[3px] after:border-dotted after:border-(--cab-plum)/40 after:content-[""]'
                                            )}
                                        >
                                            {s.label}
                                        </dt>
                                        <dd className='m-0 text-right text-[15px] text-(--cab-teal) md:text-base'>{s.value}</dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>

                    <div className='h-1.5 bg-(--cab-plum) md:h-auto' aria-hidden />

                    <div className='flex min-w-0 flex-col gap-6 p-6 md:p-10'>
                        <SectionHead icon='book' label="Story" />
                        <div className='flex flex-col gap-4'>
                            {ABOUT.story.map((p) => (
                                <p key={p} className={ARC.text}>
                                    {p}
                                </p>
                            ))}
                        </div>

                        <div className='flex flex-col gap-4'>
                            <SectionHead icon='projects' label="Main quests" />
                            <ul className='m-0 flex list-none flex-wrap gap-2.5 p-0' aria-label="What I focus on">
                                {ABOUT.focus.map((f) => (
                                    <li
                                        key={f}
                                        className={cn(
                                            ARC.pixel,
                                            'bg-(--cab-sage) px-2.5 py-1.5 text-[11px] tracking-[0.06em] shadow-[inset_0_0_0_2px_var(--cab-plum)]'
                                        )}
                                    >
                                        {f}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </PixelPanel>
        </section>
    )
}

export default Profile
